import actionCreatorFactory from 'typescript-fsa';
import {Profile} from './State';

const profilerCreator = actionCreatorFactory('PROFILER');
export const resetProfilerAction = profilerCreator<void>('RESET');
export const setProfilerAction = profilerCreator<{ key: string, value: Profile }>('SET');